import { render, staticRenderFns } from "./Home.global-offers.vue?vue&type=template&id=3339ba3a&scoped=true&"
import script from "./Home.global-offers.vue?vue&type=script&lang=js&"
export * from "./Home.global-offers.vue?vue&type=script&lang=js&"
import style0 from "./Home.global-offers.vue?vue&type=style&index=0&id=3339ba3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339ba3a",
  null
  
)

export default component.exports